import { Typography } from '@spotnana/blocks/src/Typography/Typography';
import { Row } from './styles';

interface IProps {
  text: string;
}

export const Info = ({ text }: IProps) => {
  return (
    <Row>
      <Typography variant="body3" color="disabled">
        {text}
      </Typography>
    </Row>
  );
};
